@if (!isSaved) {
  <i
    class="float-right ri-loader-line"
  ></i>
}
@if (isSaved) {
  <i
    class="float-right ri-check-line"
    style="color: #f6a600"
  ></i>
}